import React, { ReactNode } from 'react'
import { DispatchProp } from 'react-redux'
import { connectRedux } from '../../../helpers/connectRedux'
import { RouteComponentProps, withRouter } from '../../../helpers/withRouter'

import { Button, Page, Radiobutton, Select, Spinner, StopsRouteDots, SuggestionButton } from '../../../components'
import { AuthenticatedRoutable, IAvailability, IServiceInfo, IStop, ISuggestionComplaint, ISuggestionType } from '../../../models'
import { urls } from '../../../routing'
import { LiteralsService, TownService } from '../../../services'
import {
  fetchReturnRouteOptionsAction,
  fetchRouteOptionsAction,
  resetNewReservationFieldsAction,
  resetSingleBusStopAction,
  setDestinationAvailabilityAction,
  setPickedDateAction,
  setPickedSeatsAction,
  setReturnDestinationAvailabilityAction,
  setReturnPickedDateAction,
  setReturnTypeSpecificDateFlag,
  setTypeSpecificDateFlag,
  setWeekDaysListReturnAction
} from '../../../store/actions'
import { IStoreState } from '../../../store/states'
import StyledArticle from '../styles'
import { SeatsModal } from './SeatsModal'
import { StyledHeaderContainer, StyledMapContainer, StyledSeatsContainer, StyledStopsSummaryContainer, StyledTimeContainer, StyledWeekdaysPickerContainer } from './styles'
import 'react-calendar/dist/Calendar.css'
import { ReservationInstructions } from '../../../containers/NewReservation/Instructions'
import theme from '../../../theme'
import moment from 'moment'
import { appsStyleSelected, appsSuggestionsAlertsSelected } from '../../../helpers/app'
import { MapSlot } from '../../../containers'
import { images } from '../../../images'
import { Application } from '../../../config'

const { isIframe } = Application
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css/bundle'
import { IWeekday } from '../../../models/weekday'
import { calculateMinutesToArrive, firstLetterLowercase, getdayOfTheWeek, getMonth, getWeekDays } from '../../../helpers'
import { CalendarModal } from './CalendarModal'
import { IFindResultAvailabilities } from '../../../models/find-result-availabilities'
import { IExpeditionStatus } from '../../../models/expedition-status'
import literalsService from '../../../services/literals-service'
import { AnyAction } from 'redux'

interface IProps extends DispatchProp<AnyAction>, RouteComponentProps {
  pickedOriginBusStop?: IStop
  pickedDestinationBusStop?: IStop
  specificDate: boolean
  pickedDate: Date
  pickedSeats: number
  pickedPrmSeats: number
  isFetchingRouteOptions: boolean
  isWheelPicker: boolean
  routeOptionsAndFailures: IFindResultAvailabilities
  pickedAvailability: IAvailability
  serviceInfos: IServiceInfo[]
  townId: number
  isRoundTrip: boolean
  isFetchingReturnRouteOptions: boolean
  returnRouteOptionsAndFailures: IFindResultAvailabilities
  returnPickedDate: Date
  returnSpecificDate: boolean
  returnPickedAvailability: IAvailability,
  isEdit: boolean,
  pickedTownId: number,
  pickedReservationId: number,
  pickedRelatedReservationId: number
  pickedServiceInfo: number
  persistedWeekDaysListReturn: IWeekday[]
}

interface IState {
  displaySeatsModal: boolean
  displayCalendar: boolean
  modalIsReturnMode: boolean
  desiredDate: Date
  desiredHour?: string
  weekDaysList: IWeekday[]
  weekDaysListReturn: IWeekday[]
  originalWeekDaysListReturn: IWeekday[]
  loadingWeekdays: boolean;
  loadingWeekdaysReturn: boolean;
  desiredAvailabilityId?: number
  returnDesiredDate?: Date
  returnDesiredHour?: string
  returnDesiredAvailabilityId?: number
  weekdaysSwiperLocked: boolean
  weekdaysSwiperLockedReturn: boolean
  isAutoAdvancingReturnDate: boolean
}

class DateStep extends AuthenticatedRoutable<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      displaySeatsModal: false,
      displayCalendar: false,
      modalIsReturnMode: false,
      desiredDate: new Date(),
      desiredHour: moment(props.pickedDate ?? '').format('HH:mm'),
      weekDaysList: [],
      weekDaysListReturn: [],
      originalWeekDaysListReturn: [],
      loadingWeekdays: true,
      loadingWeekdaysReturn: true,
      desiredAvailabilityId: undefined,
      returnDesiredDate: new Date(props.returnPickedDate ?? ''),
      returnDesiredHour: moment(props.returnPickedDate ?? '').format('HH:mm'),
      returnDesiredAvailabilityId: undefined,
      weekdaysSwiperLocked: false,
      weekdaysSwiperLockedReturn: false,
      isAutoAdvancingReturnDate: false
    }
  }

  public componentDidMount(): void {
    if (!this.bookingTownId) super.componentDidMount()
    this.getWeekDaysList()
  }

  // The town being booked: the one the stops step carried over (URL town), else the profile's.
  private get bookingTownId(): number {
    const { history, townId } = this.props
    const stateTownId = history.location.state?.townId
    return stateTownId ? Number(stateTownId) : townId
  }

  componentDidUpdate(prevProps: IProps): void {
    const { pickedAvailability, returnPickedAvailability, routeOptionsAndFailures, returnRouteOptionsAndFailures, isFetchingRouteOptions, isFetchingReturnRouteOptions, dispatch, pickedRelatedReservationId, isRoundTrip } = this.props

    if (routeOptionsAndFailures && routeOptionsAndFailures.availabilities && !pickedAvailability) {
      if (routeOptionsAndFailures.availabilities.length === 1) {
        const availabilityOption = routeOptionsAndFailures.availabilities[0]
        this.handleSelectAvailability(availabilityOption.id, availabilityOption.inStop.dateTime, false)
      }
    }

    if (prevProps.pickedAvailability?.id !== pickedAvailability?.id && pickedAvailability) {
      const { originalWeekDaysListReturn } = this.state
      const firstDay = originalWeekDaysListReturn.find((day) => moment(day.date).isSameOrAfter(moment(pickedAvailability.dateTime), 'day'))

      if (firstDay) {
        this.setState({ weekDaysListReturn: [], returnDesiredDate: firstDay.date, returnDesiredAvailabilityId: undefined, isAutoAdvancingReturnDate: true })
        dispatch(setReturnPickedDateAction(firstDay.date))
        dispatch(fetchReturnRouteOptionsAction(false, 40, true, pickedRelatedReservationId))
      } else {
        if (isRoundTrip) {
          this.setState({ weekDaysListReturn: [], isAutoAdvancingReturnDate: false, loadingWeekdaysReturn: false })
          dispatch(setWeekDaysListReturnAction([]))
          this.handleSelectAvailability(undefined, undefined, true)
        }
      }
    }

    if (!isFetchingReturnRouteOptions && returnRouteOptionsAndFailures?.availabilities && pickedAvailability && prevProps.returnRouteOptionsAndFailures !== returnRouteOptionsAndFailures && prevProps.pickedAvailability?.id === pickedAvailability?.id) {
      const { originalWeekDaysListReturn, weekDaysListReturn, returnDesiredDate, isAutoAdvancingReturnDate } = this.state
      const filteredAvailabilities = returnRouteOptionsAndFailures.availabilities.filter((availability) => moment(availability.dateTime).isAfter(pickedAvailability.dateTime))

      if (isAutoAdvancingReturnDate) {
        const currentDateIndex = originalWeekDaysListReturn.findIndex((day) => moment(day.date).isSame(moment(returnDesiredDate), 'day'))

        if (filteredAvailabilities.length === 0) {
          const nextDay = originalWeekDaysListReturn.slice(currentDateIndex + 1).find((day) => moment(day.date).isSameOrAfter(moment(pickedAvailability.dateTime), 'day'))
          const updatedDisplayList = weekDaysListReturn.filter((day) => !moment(day.date).isSame(moment(returnDesiredDate), 'day'))

          if (nextDay) {
            this.setState({ weekDaysListReturn: updatedDisplayList, returnDesiredDate: nextDay.date, returnDesiredAvailabilityId: undefined })
            dispatch(setReturnPickedDateAction(nextDay.date))
            dispatch(fetchReturnRouteOptionsAction(false, 40, true, pickedRelatedReservationId))
          } else {
            this.setState({ weekDaysListReturn: updatedDisplayList, loadingWeekdaysReturn: false })
            dispatch(setWeekDaysListReturnAction(updatedDisplayList))
            this.handleSelectAvailability(undefined, undefined, true)
          }
        } else {
          const revealedDates = originalWeekDaysListReturn.slice(currentDateIndex).filter((day) => moment(day.date).isSameOrAfter(moment(pickedAvailability.dateTime), 'day'))
          this.setState({ weekDaysListReturn: revealedDates, isAutoAdvancingReturnDate: false, loadingWeekdaysReturn: false })
          dispatch(setWeekDaysListReturnAction(revealedDates))
        }
      }

      if (filteredAvailabilities.length === 1) {
        const availabilityOption = returnRouteOptionsAndFailures.availabilities[0]
        this.handleSelectAvailability(availabilityOption.id, availabilityOption.inStop.dateTime, true)
      }
    }

    this.setState({
      desiredAvailabilityId: isFetchingRouteOptions ? undefined : pickedAvailability?.id,
      returnDesiredAvailabilityId: isFetchingReturnRouteOptions ? undefined : returnPickedAvailability?.id
    })
  }

  private get isEveryFieldValid(): boolean {
    const { pickedSeats, pickedPrmSeats, isWheelPicker, isRoundTrip } = this.props
    const { desiredDate, desiredHour, desiredAvailabilityId, returnDesiredAvailabilityId } = this.state

    if (isWheelPicker) return ((!!pickedSeats || !!pickedPrmSeats) && desiredDate !== undefined && desiredHour !== undefined)
    if (isRoundTrip) return desiredAvailabilityId !== undefined && returnDesiredAvailabilityId !== undefined
    return desiredAvailabilityId !== undefined
  }

  private normalSeatsText(seats: number): ReactNode {
    if (seats <= 0) return null
    return (
      <div className='seat-container'>
        <img src={images.seat} alt='seat' />
        <p>
          { `${seats} ${LiteralsService.get(seats > 1 ? 'seats' : 'seat')}` }
        </p>
      </div>
    )
  }

  private prmSeatsText(prmSeats: number): ReactNode {
    if (prmSeats <= 0) return null
    return (
      <div className='seat-container'>
        <img src={images.prmSeat} alt='prm_seat' />
        <p>
          { `${prmSeats} ${LiteralsService.get('prmSeat')}` }
        </p>
      </div>
    )
  }

  private get nextButton(): ReactNode {
    const { isFetchingRouteOptions, dispatch, isWheelPicker, history, isRoundTrip, pickedReservationId, pickedRelatedReservationId } = this.props

    if (isWheelPicker && isFetchingRouteOptions) return <Spinner />
    return (
      <Button
        title={ LiteralsService.get('next') }
        onPress={ () => {
          if (isWheelPicker) {
            dispatch(fetchRouteOptionsAction(true, 2, undefined, pickedReservationId))
            if (isRoundTrip) dispatch(fetchReturnRouteOptionsAction(true, 2, undefined, pickedRelatedReservationId))
          } else {
            history.push(urls.newReservationConfirmationStep, {
              userData: history.location.state?.userData,
              townId: history.location.state?.townId,
            })
          }
        }}
        isDisabled={ !this.isEveryFieldValid }
        styles={{
          boxShadow: `0px 4px 4px 0px ${theme.colors.primary}40`
        }}
        filled
        upper
      />
    )
  }

  private get instructions(): ReactNode {
    return (
      <ReservationInstructions
        textTitle= { LiteralsService.get('tutorialChooseWhenToGoTitle', true) }
        textContent= { LiteralsService.get(isIframe ? 'tutorialChooseWhenToGoIframeContent' : 'tutorialChooseWhenToGoContent', true) }
        backgroundColor= { theme.colors.greyLight }
      />
    )
  }

  private get mapDisplay(): ReactNode {
    if (!this.bookingTownId) return null
    return (
      <StyledMapContainer>
        <MapSlot />
      </StyledMapContainer>
    )
  }

  private stopsSummary(isReturn?: boolean): ReactNode {
    const { pickedOriginBusStop, pickedDestinationBusStop } = this.props
    const origin = isReturn ? pickedDestinationBusStop : pickedOriginBusStop
    const destination = isReturn ? pickedOriginBusStop : pickedDestinationBusStop
    return (
      <StyledStopsSummaryContainer>
        <label> { origin?.name } </label>
        <StopsRouteDots
          colorStart={ theme.colors.accent }
          colorEnd={ theme.colors.greenRadio }
          horizontal={ true }
        />
        <label> { destination?.name } </label>
      </StyledStopsSummaryContainer>
    )
  }

  private get seatSelector(): ReactNode {
    const { pickedSeats, pickedPrmSeats } = this.props

    return (
      <StyledSeatsContainer>
        <div>
          { this.normalSeatsText(pickedSeats) }
          { this.prmSeatsText(pickedPrmSeats) }
        </div>
        <div className='link-action' onClick={this.toggleSeatsModal }>
          { LiteralsService.get('edit', true) }
        </div>
      </StyledSeatsContainer>
    )
  }

  private weekdayPicker(isReturn?: boolean) {
    const { pickedDate } = this.props
    const { weekDaysList, weekDaysListReturn, desiredDate, returnDesiredDate, weekdaysSwiperLocked, weekdaysSwiperLockedReturn } = this.state
    const days = isReturn ? weekDaysListReturn.filter((day) => moment(day.date).isSameOrAfter(moment(pickedDate), 'days')) : weekDaysList
    const isLocked = isReturn ? weekdaysSwiperLockedReturn : weekdaysSwiperLocked
    const updateLocked = (swiper: any) => {
      if (!swiper) return
      const fits = typeof swiper.virtualSize === 'number' && typeof swiper.size === 'number'
        ? swiper.virtualSize <= swiper.size + 1
        : !!swiper.isLocked
      if (isReturn) {
        if (this.state.weekdaysSwiperLockedReturn !== fits) this.setState({ weekdaysSwiperLockedReturn: fits })
      } else {
        if (this.state.weekdaysSwiperLocked !== fits) this.setState({ weekdaysSwiperLocked: fits })
      }
    }
    return (
      <StyledWeekdaysPickerContainer>
        <Swiper
          slidesPerView={'auto'}
          freeMode={true}
          watchOverflow={true}
          observer={true}
          observeParents={true}
          onSwiper={ updateLocked }
          onResize={ updateLocked }
          onObserverUpdate={ updateLocked }
        >
          {
            days.map((weekday, index) => (
              <SwiperSlide
                key={`weekday-${index}`}
                className={`weekday-card ${moment(isReturn ? returnDesiredDate : desiredDate).isSame(weekday.date, 'day') ? 'selected' : ''}`}
                onClick={() => {
                  this.handleDateChange(weekday.date, isReturn ?? false)
                }}>
                <div className='weekday'>
                  <span>{ weekday.weekday }</span>
                </div>
                <div className='day-month'>
                  <span>{ weekday.day } </span>
                  <span>{ weekday.month }</span>.
                </div>
              </SwiperSlide>
            ))
          }
        </Swiper>
        { !isLocked &&
          <div className='more-dates-container'>
            <div className='link-action' onClick={ () => this.toggleCalendarModal(isReturn ?? false) }>
              <label>{ LiteralsService.get('moreDates', true) }</label>
            </div>
          </div>
        }
      </StyledWeekdaysPickerContainer>
    )
  }

  private timeSelector(isReturn?: boolean) {
    const { specificDate, returnSpecificDate } = this.props
    const { desiredHour, returnDesiredHour } = this.state

    const timeFlags = [
      {
        value: false,
        label: LiteralsService.get('takeAfter', true)
      },
      {
        value: true,
        label: LiteralsService.get('arriveBefore', true)
      }
    ]

    const time: any[] = []
    let hour = 0
    let minute = 0
    do {
      if (minute !== 45) {
        minute = minute + 15
      } else {
        hour = hour + 1
        minute = 0
      }

      const hourString = hour < 10 ? `0${ hour }` : `${ hour }`
      const minuteString = minute < 10 ? `0${ minute }` : `${ minute }`
      const timeString = `${ hourString }:${ minuteString }`;
      time.push({
        value: timeString,
        label: timeString
      })
    } while (time[time.length - 1].value !== '23:45')

    return (
      <div className='wheelpicker-container'>
        <div className="time-flag">
          <Select
            value={ timeFlags.find((flag) => flag.value === (isReturn ? returnSpecificDate : specificDate))!.label }
            options={ timeFlags }
            placeholder={ LiteralsService.get('hour', true) }
            onChange={ (value) => this.handleFlagClick(value, isReturn ?? false) }
          />
        </div>
        <div className="hour">
          <Select
            value={ (isReturn ? returnDesiredHour : desiredHour) ?? '' }
            options={ time }
            placeholder={ LiteralsService.get('hour', true) }
            onChange={ (value) => this.handleHourChange(value, isReturn ?? false) }
          />
        </div>
      </div>
    )
  }

  private expeditionOption(id: number, time: string, reason: string | null, realTime?: boolean, isReturn?: boolean, disabled?: boolean): ReactNode {
    const { desiredAvailabilityId, returnDesiredAvailabilityId } = this.state
    const isSelected = isReturn ? returnDesiredAvailabilityId === id : desiredAvailabilityId === id
    let textState = ''
    if (reason) textState = LiteralsService.get(`failureReasons.${firstLetterLowercase(reason)}`, true)
    else textState = LiteralsService.get(realTime ? 'isComing' : 'available', true)
    return (
      <div
        key={`availability-option-${id}`}
        className={`availability-option ${reason ? 'disabled' : '' } ${isSelected ? 'selected' : '' }`}
        onClick={() => this.handleSelectAvailability(id, time, isReturn ?? false)}
      >
        <div className='time-container'>
          <Radiobutton
            id={id}
            selected={isSelected}
            icon={realTime ? images.realTime : images.clock}
            label={
              realTime ?
              LiteralsService.get('inMinutes').replace('{0}', String(calculateMinutesToArrive(time)))
              :
              moment(time).format('HH:mm')
            }
            disabled={disabled}
          />
        </div>
        <div className='state-container'>
          <span className={`${reason ? 'failure-text' : 'state-text'}`}>
            { textState }
          </span>
        </div>
      </div>
    )
  }

  private availabilities(isReturn?: boolean) {
    const { isFetchingRouteOptions, isFetchingReturnRouteOptions, routeOptionsAndFailures, returnRouteOptionsAndFailures, pickedAvailability } = this.props
    let availabilities: any[] = []
    if (isReturn) {
      if ((routeOptionsAndFailures && routeOptionsAndFailures.availabilities && routeOptionsAndFailures.availabilities.length > 0) && returnRouteOptionsAndFailures && returnRouteOptionsAndFailures.availabilities && returnRouteOptionsAndFailures.failureAvailabilities) {
        availabilities = [
          ...returnRouteOptionsAndFailures.availabilities || [],
          ...returnRouteOptionsAndFailures.failureAvailabilities.map((availability) => ({ ...availability, disabled: true})) || []
        ]
        if (pickedAvailability) {
          availabilities = [
            ...returnRouteOptionsAndFailures.availabilities.filter((availability) => moment(availability.dateTime).isAfter(pickedAvailability.dateTime)) || [],
            ...returnRouteOptionsAndFailures.failureAvailabilities.filter((availability) => moment(availability.dateTime).isAfter(pickedAvailability.dateTime)) || []
          ]
        }
      }
    } else {
      if (routeOptionsAndFailures && routeOptionsAndFailures.availabilities && routeOptionsAndFailures.failureAvailabilities) {
        availabilities = [
          ...routeOptionsAndFailures.availabilities || [],
          ...routeOptionsAndFailures.failureAvailabilities.map((availability) => ({ ...availability, disabled: true})) || []
        ]
      }
    }
    availabilities = availabilities.sort((a, b) => moment(a.dateTime).diff(moment(b.dateTime)))

    if (isReturn && isFetchingReturnRouteOptions || !isReturn && isFetchingRouteOptions) return (
      <div className='spinner-container'>
        <Spinner />
      </div>
    )
    
    if (availabilities.length === 0) return (
      <div className='no-availabilities'>
        <span className='title'>{ LiteralsService.get('noAvailabilities.title', true) }</span>
        <span>{ LiteralsService.get('noAvailabilities.description', true) }</span>
      </div>
    )

    return (
      <div className={`availabilities-container ${appsStyleSelected?.style}`}>
        {
          availabilities.map((availability) => {
            return this.expeditionOption(
              availability.id,
              availability.inStop.dateTime,
              availability.reason ? availability.reason : null,
              availability.status === IExpeditionStatus.Ongoing,
              isReturn,
              availability?.disabled
            )
          })
        }
      </div>
    )
  }

  // "Suggest a new timetable" opens the suggestions form pre-filled, as on the app.
  private suggestSchedule = (): void => {
    this.props.history.push(urls.configuration.complaintsAndSuggestions, {
      predefinedSuggestionType: ISuggestionType.SUGGESTION,
      predefinedSuggestion: ISuggestionComplaint.TIMETABLES
    })
  }

  public handleGoBack = () => {
    const { history, dispatch, pickedAvailability, serviceInfos, pickedOriginBusStop, pickedDestinationBusStop, isEdit } = this.props
    const stop: any = pickedDestinationBusStop || pickedOriginBusStop;
    const nextState = {
      userData: history.location.state?.userData,
      townId: history.location.state?.townId,
    }

    // An edit goes back with the booked trip untouched: resetting the fields would drop the edit,
    // and the trip would be booked anew instead of updated.
    if (isEdit) {
      history.push(urls.newReservationBusStopsStep, nextState)
      return
    }

    // With availabilities. An edit carries the booked availability as an id only, with no
    // serviceInfo on it.
    const serviceInfoId = pickedAvailability?.serviceInfo?.id
    const availabilityServiceInfo = serviceInfos.find((serviceInfo: IServiceInfo) => serviceInfo.id === serviceInfoId)

    // With wheel picker
    const serviceInfo = serviceInfos.find((serviceInfo: IServiceInfo) => stop?.serviceInfo ? serviceInfo.id === stop.serviceInfo.id : serviceInfo.id === stop?.serviceId)

    if (availabilityServiceInfo?.singleStopReservations || (stop && serviceInfo?.singleStopReservations) || pickedAvailability?.serviceInfo?.singleStopReservations) {
      dispatch(resetSingleBusStopAction())
    } else {
      dispatch(resetNewReservationFieldsAction())
    }
    history.push(urls.newReservationBusStopsStep, nextState)
  }

  public render(): ReactNode {
    const { pickedSeats, pickedPrmSeats, isWheelPicker, isRoundTrip, serviceInfos, pickedServiceInfo, isFetchingReturnRouteOptions } = this.props
    const { desiredDate, weekDaysList, weekDaysListReturn, loadingWeekdays, loadingWeekdaysReturn, modalIsReturnMode, returnDesiredDate, isAutoAdvancingReturnDate } = this.state

    const serviceInfo = serviceInfos.find((serviceInfo) => serviceInfo.id === pickedServiceInfo)

    const renderAvailabilities = (isReturn: boolean) => {
      const daysList = isReturn ? weekDaysListReturn : weekDaysList
      const loading = isReturn ? loadingWeekdaysReturn : loadingWeekdays

      if (loading || (isReturn && isFetchingReturnRouteOptions && isAutoAdvancingReturnDate)) return (
        <div className='skeleton-weekdays'>
          { [0,1,2,3,4,5,6].map(i => <div key={ i } className='skeleton-card skeleton-weekday-card' />) }
        </div>
      )

      if (daysList.length === 0) return (
        <StyledTimeContainer>
          <div className='no-availabilities'>
            <span className='title'>{ LiteralsService.get('noAvailabilities.title', true) }</span>
          </div>
        </StyledTimeContainer>
      )

      return (
        <>
          { this.weekdayPicker(isReturn) }
          <StyledTimeContainer style={{ overflow: 'auto' }}>
            { !isWheelPicker && this.availabilities(isReturn) }
          </StyledTimeContainer>
        </>
      )
    }

    return (
      <Page className={ `authenticated ${appsStyleSelected?.style}` }>
        <StyledArticle className={`${isRoundTrip ? 'split' : ''} ${appsStyleSelected?.style}`}>
          <div>
            <StyledHeaderContainer>
              <div className='header-content'>
                { !isIframe &&
                  <h3>
                    { LiteralsService.get('desiredDate').toUpperCase() }
                  </h3>
                }
                { this.instructions }
              </div>
            </StyledHeaderContainer>
            <section className='card-container'>
              { !isRoundTrip && this.mapDisplay }
              <div className={`details-wrapper ${appsStyleSelected?.style}`}>
                <div className={`info-container ${appsStyleSelected?.style}`}>
                  { this.stopsSummary(false) }
                  {
                    (isWheelPicker || !isIframe) &&
                    <div className='seats-container'>
                      {
                        isWheelPicker &&
                        <StyledTimeContainer style={{ overflow: 'visible', maxHeight: '32px' }}>
                          { this.timeSelector(false) }
                        </StyledTimeContainer>
                      }
                      { !isIframe && this.seatSelector }
                    </div>
                  }
                </div>
                {
                  isRoundTrip &&
                  <div className='direction-container'>
                    <img src={images.directionArrow} />
                    <span> { literalsService.get('directions.outboundJourney').toUpperCase() } </span>
                  </div>
                }
              </div>
              { renderAvailabilities(false) }
              { appsSuggestionsAlertsSelected?.suggestSchedule &&
                <div className='suggestion-box'>
                  <SuggestionButton
                    kind='schedule'
                    label={ LiteralsService.get('suggestNewSchedule', true) }
                    onPress={ this.suggestSchedule }
                  />
                </div>
              }
            </section>
            {
              isRoundTrip && 
              <section className='card-container'>
                <div className={`details-wrapper ${appsStyleSelected?.style}`}>
                  <div className={`info-container ${appsStyleSelected?.style}`}>
                    { this.stopsSummary(true) }
                    {
                      (isWheelPicker || !isIframe) &&
                      <div className='seats-container'>
                        {
                          isWheelPicker &&
                          <StyledTimeContainer style={{ overflow: 'visible', maxHeight: '32px' }}>
                            { this.timeSelector(true) }
                          </StyledTimeContainer>
                        }
                        { !isIframe && this.seatSelector }
                      </div>
                    }
                  </div>
                  <div className='direction-container'>
                    <img className='return' src={images.directionArrow} />
                    <span> { literalsService.get('directions.returnJourney').toUpperCase() } </span>
                  </div>
                </div>
                { renderAvailabilities(true) }
              </section>
            }
            <footer>
              <section className='buttons-wrapper'>
                { this.nextButton }
                <Button
                  title={ LiteralsService.get('previous') }
                  onPress={ this.handleGoBack }
                  styles={{
                    backgroundColor: theme.colors.white,
                    borderColor: theme.colors.primary,
                    borderWidth: 2,
                    boxShadow: `0px 4px 4px 0px ${theme.colors.primary}40`
                  }}
                  upper
                />
              </section>
            </footer>
          </div>
        </StyledArticle>
        <SeatsModal
          visible={ this.state.displaySeatsModal }
          seats={ pickedSeats }
          prmSeats={ pickedPrmSeats }
          showPrm={ serviceInfo?.prmSeatsAvailable ?? true }
          onSave={ (seats, prmSeats) => this.handleSaveSeats(seats, prmSeats) }
          close={ this.toggleSeatsModal }
          />
        <CalendarModal
          visible={ this.state.displayCalendar }
          selectedDay={ modalIsReturnMode ? returnDesiredDate! : desiredDate }
          availableDates={ weekDaysList }
          onSave={ (date) => this.handleDateChange(date, modalIsReturnMode) }
          close={ () => this.toggleCalendarModal(false) }
        />
      </Page>
    )
  }


  private handleFlagClick = (flag: boolean, isReturn: boolean) => {
    const { dispatch } = this.props

    if (isReturn) dispatch(setReturnTypeSpecificDateFlag(flag))
    else dispatch(setTypeSpecificDateFlag(flag))
  }

  private toggleSeatsModal = () => {
    this.setState({
      displaySeatsModal: !this.state.displaySeatsModal
    })
  }

  private toggleCalendarModal = (isReturn: boolean) => {
    this.setState({
      displayCalendar: !this.state.displayCalendar,
      modalIsReturnMode: isReturn
    })
  }

  private handleSaveSeats = (seats: number, prmSeats: number) => {
    const { dispatch, isRoundTrip, isWheelPicker, pickedReservationId, pickedRelatedReservationId } = this.props

    dispatch(setPickedSeatsAction(seats, prmSeats))
    if (!isWheelPicker) {
      if (isRoundTrip) dispatch(fetchReturnRouteOptionsAction(false, 40, true, pickedRelatedReservationId))
      dispatch(fetchRouteOptionsAction(false, 40, true, pickedReservationId))
    }
    this.setState({
      displaySeatsModal: !this.state.displaySeatsModal
    })
  }

  private handleDateChange = (date: Date | Date[], isReturn: boolean) => {
    const { dispatch, isWheelPicker, isRoundTrip, pickedReservationId, pickedRelatedReservationId } = this.props
    const { desiredHour, displayCalendar, weekDaysList, weekDaysListReturn } = this.state
    const desiredDate = date instanceof Date ? date : date[0]

    if (isReturn) {
      const weekdayIndex = weekDaysListReturn.findIndex((weekday) => moment(weekday.date).format('YYYY-MM-DD') === moment(desiredDate).format('YYYY-MM-DD'))
      if (weekdayIndex === -1) weekDaysListReturn[weekDaysListReturn.length - 1] = {
        day: desiredDate.getDate().toString(),
        weekday: getdayOfTheWeek(desiredDate.getDay()),
        month: getMonth(desiredDate.getMonth()),
        date: desiredDate,
        index: weekDaysListReturn.length + 1
      }
    } else {
      const weekdayIndex = weekDaysList.findIndex((weekday) => moment(weekday.date).format('YYYY-MM-DD') === moment(desiredDate).format('YYYY-MM-DD'))
      if (weekdayIndex === -1) weekDaysList[weekDaysList.length - 1] = {
        day: desiredDate.getDate().toString(),
        weekday: getdayOfTheWeek(desiredDate.getDay()),
        month: getMonth(desiredDate.getMonth()),
        date: desiredDate,
        index: weekDaysList.length + 1
      }
    }

    if (displayCalendar) this.toggleCalendarModal(false)

    if (desiredHour && isWheelPicker) {
      const hour = parseInt(desiredHour.split(':')[0])
      const minute = parseInt(desiredHour.split(':')[1])
      desiredDate.setHours(hour, minute)
    }

    if (isReturn) {
      this.setState({
        returnDesiredDate: desiredDate,
        returnDesiredAvailabilityId: undefined,
        isAutoAdvancingReturnDate: false
      })
      dispatch(setReturnPickedDateAction(desiredDate))
    } else {
      this.setState({ 
        desiredDate,
        desiredAvailabilityId: undefined
      })
      dispatch(setPickedDateAction(desiredDate))
      
      if (isRoundTrip) {
        const days = weekDaysListReturn.filter((day) => moment(day.date).isSameOrAfter(moment(desiredDate)));
        if (days.length > 0) {
          this.setState({
            returnDesiredDate: days[0].date,
            returnDesiredAvailabilityId: undefined
          })
          dispatch(setReturnPickedDateAction(days[0].date))
          dispatch(fetchReturnRouteOptionsAction(false, 40, true))
        }
      }
    }
    if (!isWheelPicker) {
      if (isReturn) dispatch(fetchReturnRouteOptionsAction(false, 40, true, pickedRelatedReservationId))
      else dispatch(fetchRouteOptionsAction(false, 40, true, pickedReservationId))
    }
  }

  private handleHourChange = (time: string, isReturn: boolean) => {
    const { dispatch, pickedDate } = this.props
    const desiredDate = pickedDate ? pickedDate : new Date()
    const hour = parseInt(time.split(':')[0])
    const minute = parseInt(time.split(':')[1])
    desiredDate.setHours(hour, minute)

    if (isReturn) {
      this.setState({ returnDesiredHour: time })
      dispatch(setReturnPickedDateAction(desiredDate))
    } else {
      this.setState({ desiredHour: time })
      dispatch(setPickedDateAction(desiredDate))
    }
  }

  private handleSelectAvailability(availabilityId: number | undefined, date: string | undefined, isReturn: boolean): void {
    const { dispatch, routeOptionsAndFailures, returnRouteOptionsAndFailures } = this.props
    if (isReturn) {
      this.setState({
        returnDesiredAvailabilityId: availabilityId
      })
      const selectedAvailability = returnRouteOptionsAndFailures.availabilities.find((availability: IAvailability) => availability.id === availabilityId)
      dispatch(setReturnDestinationAvailabilityAction(selectedAvailability))
    } else {
      this.setState({
        desiredAvailabilityId: availabilityId
      })
      const selectedAvailability = routeOptionsAndFailures.availabilities.find((availability: IAvailability) => availability.id === availabilityId)
      dispatch(setDestinationAvailabilityAction(selectedAvailability!))
      dispatch(setPickedDateAction(moment(date).toDate()))
    }
  }

  private getMaxDaysInAdvance(serviceInfos: IServiceInfo[]) {
    return serviceInfos.reduce(
      (max, serviceInfo) => Math.max(max, serviceInfo.bookingDaysInAdvance),
      0
    );
  }

  private async getWeekDaysList() {
    const { serviceInfos, pickedOriginBusStop, pickedDestinationBusStop, pickedDate, returnPickedDate, isWheelPicker, isRoundTrip, isEdit, pickedTownId, pickedReservationId, pickedRelatedReservationId, dispatch, pickedAvailability, persistedWeekDaysListReturn } = this.props

    let weekDaysResult: any = []
    let weekDaysResultReturn: any = []

    const daysInAdvance = this.getMaxDaysInAdvance(serviceInfos)
    const startDate = moment()
    const endDate = moment()
    endDate.add(daysInAdvance, 'days')

    const isSingleStop = pickedOriginBusStop?.serviceInfo?.singleStopReservations || pickedDestinationBusStop?.serviceInfo?.singleStopReservations

    // Door to door stops are map points, so they have no id the backend knows:
    // asking for their available dates would just be a bad request.
    const backendStopId = (stop?: IStop) => typeof stop?.id === 'number' ? stop.id : undefined
    const originStopId = backendStopId(pickedOriginBusStop)
    const destinationStopId = backendStopId(pickedDestinationBusStop)
    const availableDatesTownId = isEdit ? pickedTownId : this.bookingTownId

    this.setState({ loadingWeekdays: true, loadingWeekdaysReturn: true })
    await TownService.getAvailableDates(availableDatesTownId, startDate.toDate(), endDate.toDate(), originStopId, destinationStopId, undefined, isSingleStop).then((availableDays) => {
      weekDaysResult = getWeekDays(availableDays)
    }).catch(() => { weekDaysResult = [] })

    if (isRoundTrip) {
      await TownService.getAvailableDates(availableDatesTownId, startDate.toDate(), endDate.toDate(), destinationStopId, originStopId, undefined, isSingleStop).then((availableDays) => {
        weekDaysResultReturn = getWeekDays(availableDays).filter((day: any) => moment(day.date).isSameOrAfter(moment(weekDaysResult[0].date)));
      }).catch(() => { weekDaysResultReturn = [] })
    }

    let initialDesiredDate = pickedDate ? new Date(pickedDate) : weekDaysResult[0]?.date
    let initialReturnDesiredDate = returnPickedDate ? new Date(returnPickedDate) : weekDaysResultReturn[0]?.date

    if (weekDaysResult.length > 0 && !weekDaysResult.some((weekday: any) => moment(weekday.date).isSame(moment(initialDesiredDate), 'date'))) {
      initialDesiredDate = weekDaysResult[0].date
    }
    if (isRoundTrip && weekDaysResultReturn.length > 0 && !weekDaysResultReturn.some((weekday: any) => moment(weekday.date).isSame(moment(initialReturnDesiredDate), 'date'))) {
      initialReturnDesiredDate = weekDaysResultReturn[0].date || null
    }

    if (!isWheelPicker) {
      dispatch(setPickedDateAction(initialDesiredDate))
      dispatch(fetchRouteOptionsAction(false, 40, true, pickedReservationId))
      if (isRoundTrip && moment(initialReturnDesiredDate).isSameOrAfter(moment(initialDesiredDate), 'day')) {
        dispatch(setReturnPickedDateAction(initialReturnDesiredDate))
        dispatch(fetchReturnRouteOptionsAction(false, 40, true, pickedRelatedReservationId))
      }
    }
    
    const displayWeekDaysReturn = (pickedAvailability && persistedWeekDaysListReturn.length > 0)
      ? persistedWeekDaysListReturn
      : weekDaysResultReturn

    this.setState({
      weekDaysList: weekDaysResult,
      weekDaysListReturn: displayWeekDaysReturn,
      originalWeekDaysListReturn: weekDaysResultReturn,
      loadingWeekdays: false,
      loadingWeekdaysReturn: false,
      desiredDate: initialDesiredDate,
      returnDesiredDate: initialReturnDesiredDate
    })
  }
}

const mapStateToProps = ({ newReservation, userInfo }: IStoreState) => ({
  pickedOriginBusStop: newReservation.pickedOriginBusStop,
  pickedDestinationBusStop: newReservation.pickedDestinationBusStop,
  specificDate: newReservation.specificDate,
  pickedDate: newReservation.pickedDate,
  pickedSeats: newReservation.pickedSeats,
  pickedPrmSeats: newReservation.pickedPrmSeats,
  isFetchingRouteOptions: newReservation.isFetchingRouteOptions,
  isWheelPicker: newReservation.isWheelPicker,
  routeOptionsAndFailures: newReservation.routeOptionsAndFailures,
  pickedAvailability: newReservation.pickedAvailability,
  serviceInfos: newReservation.serviceInfos,
  townId: userInfo.town.id,
  isRoundTrip: newReservation.isRoundTrip,
  isFetchingReturnRouteOptions: newReservation.isFetchingReturnRouteOptions,
  returnRouteOptionsAndFailures: newReservation.returnRouteOptionsAndFailures,
  returnPickedDate: newReservation.returnPickedDate,
  returnSpecificDate: newReservation.returnSpecificDate,
  returnPickedAvailability: newReservation.returnPickedAvailability,
  isEdit: newReservation.isEdit,
  pickedTownId: newReservation.pickedTown,
  pickedReservationId: newReservation.pickedReservationId,
  pickedRelatedReservationId: newReservation.pickedRelatedReservationId,
  pickedServiceInfo: newReservation.pickedServiceInfo,
  persistedWeekDaysListReturn: newReservation.weekDaysListReturn
})

export default withRouter(connectRedux(mapStateToProps, DateStep as any))
